<div class="flex flex-col gap-6">
	<div
		*ngIf="!(assignedLawyer$ | async)?.closerSyncId"
		class="my-2 p-2 bg-orange text-white"
	>
		Assigned Lawyer to the file is not connected to Sync. Please connect before
		continuing.
	</div>

	<app-closer-sync-mortgage-header
		(viewDocuments)="viewDocuments()"
		(gotoArea)="gotoArea($event)"
	></app-closer-sync-mortgage-header>

	<app-closer-sync-prompts
		(gotoArea)="gotoArea($event)"
	></app-closer-sync-prompts>
	<section>
		<app-mortgage-tabs
			#mortgageTabs
			[tabs]="detailsNavOptions"
			[selectedTab]="selected"
			(tabSelected)="updateSelectedTab($event)"
		/>
		<div [ngSwitch]="selected" class="py-6">
			<ng-container *ngSwitchCase="TAB_SELECT_OPTIONS.MORTGAGE_DETAILS">
				<app-closer-sync-mortgage-details></app-closer-sync-mortgage-details>
			</ng-container>
			<ng-container *ngSwitchCase="TAB_SELECT_OPTIONS.PAYMENT">
				<app-closer-sync-terms [mortgage]="mortgage"></app-closer-sync-terms>
			</ng-container>
			<ng-container *ngSwitchCase="TAB_SELECT_OPTIONS.REPORTING_INFORMATION">
				<app-closer-sync-reporting></app-closer-sync-reporting>
			</ng-container>
			<ng-container *ngSwitchCase="TAB_SELECT_OPTIONS.DOCUMENTS">
				<app-closer-sync-documents
					(gotoArea)="gotoArea($event)"
				></app-closer-sync-documents>
			</ng-container>
		</div>
	</section>
</div>

<!-- Razzle Dazzle -->
<!-- <div class="fixed top-0 left-0 z-nuclear w-screen h-screen flex items-center justify-center" *ngIf="funded">
	<img
		class="w-full h-full object-cover"
		src="/assets/images/mortgage/money.gif"
	/>
</div>
<div class="fixed top-0 left-0 z-nuclear w-screen h-screen flex items-center justify-center" *ngIf="hype">
	<img
		class="max-w-md object-cover"
		src="/assets/images/mortgage/hype.gif"
	/>
</div> -->
